module.exports = __webpack_public_path__ + "img/50_37.79bcb6fa.png";